<template>
    <q-page bottom>
        <q-btn icon slot="activator">
            <q-icon name="upload"/>
            <input type="file" id="fileinput" multiple="multiple"/>
        </q-btn>
        <span>Dodaj pliki</span>
    </q-page>
</template>

<script>
    import QIcon from 'quasar-framework/src/components/icon/QIcon'
    export default {
        components: {QIcon},
        name: "FileUpload"
    }
</script>